import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fiche-model',
  templateUrl: './fiche-model.component.html',
  styleUrls: ['./fiche-model.component.scss']
})
export class FicheModelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
